import { getLocale } from "../runtime";

const da_easteregg2 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Husk at drikke vand, mens du browser. Små øjeblikke med selvpleje forbedrer dit daglige velvære.`
};

const en_easteregg2 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Remember to hydrate while you browse. Small moments of self-care enhance your daily wellness.`
};

const es_easteregg2 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Recuerda hidratarte mientras navegas. Pequeños momentos de autocuidado mejoran tu bienestar diario.`
};

const fi_easteregg2 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Muista juoda vettä selatessasi. Pienet itsestä huolehtimisen hetket parantavat päivittäistä hyvinvointiasi.`
};

const nb_easteregg2 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Husk å drikke vann mens du surfer. Små øyeblikk av egenomsorg styrker ditt daglige velvære.`
};

const sv_easteregg2 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kom ihåg att dricka vatten medan du surfar. Små stunder av egenvård förbättrar ditt dagliga välbefinnande.`
};

const easteregg2 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_easteregg2(inputs)
	if (locale === "en") return en_easteregg2(inputs)
	if (locale === "es") return es_easteregg2(inputs)
	if (locale === "fi") return fi_easteregg2(inputs)
	if (locale === "nb") return nb_easteregg2(inputs)
	if (locale === "sv") return sv_easteregg2(inputs)
	return "easterEgg2";
};

export { easteregg2 as "easterEgg2" };